import { Button, ButtonProps } from "@fluentui/react-components";
import { DocumentArrowDownRegular } from "@fluentui/react-icons";
import React from "react";

export default function GenerateReportBtn({ ...props }: ButtonProps) {
  return (
    <Button
      appearance="primary"
      iconPosition="after"
      icon={<DocumentArrowDownRegular />}
      aria-label="Generate report"
      {...props}
    >
      Generate Report
    </Button>
  );
}
